import { createSlice } from '@reduxjs/toolkit'
import { changeTopNavReducer } from './reducers/changeTopNavReducer'
import { toggleSideNavReducer } from './reducers/toggleSideNavReducer'
import { setDashboardChartReducer } from './reducers/setDashboardChartReducer'

export interface TopNavState {
    fixed: boolean
}

export interface SideNavState {
    toggled: boolean
}

export interface DashboardChart {
    chartType: string
    statsMonths: number
}

export interface DashboardState {
    charts?: {
        [code: string]: DashboardChart
    }
}

export interface SettingsState {
    topNav: TopNavState
    sideNav: SideNavState
    dashboard?: DashboardState
}

export const initialState: SettingsState = {
    topNav: {
        fixed: false,
    },
    sideNav: {
        toggled: false,
    },
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        changeTopNav: changeTopNavReducer,
        toggleSideNav: toggleSideNavReducer,
        setDashboardChart: setDashboardChartReducer,
    },
})

export const { changeTopNav, toggleSideNav, setDashboardChart } =
    settingsSlice.actions
export default settingsSlice.reducer
